import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { Http ,Response ,Headers, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs';
import { AWS, IPAD_URL } from '../../environments/environment';
import Amplify from 'aws-amplify';
import { DataProvider } from '../data/data';


/*
  Generated class for the RestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RestProvider {

//  private static readonly PREFIX: String = 'http://townhost.townsystem.co.jp/ipad_entry/rest';
  private static readonly PREFIX: String = IPAD_URL;
  
  constructor(public http: HttpClient) {
  }

  public login(username: string, password: string): Promise<any> {
    (window as any).global = window;
    Amplify.configure({
      Auth: {
          // REQUIRED - Amazon Cognito Identity Pool ID
          identityPoolId: AWS.identityPoolId, 
          // REQUIRED - Amazon Cognito Region
          region: AWS.region, 
          // OPTIONAL - Amazon Cognito User Pool ID
          userPoolId: AWS.userPoolId,
          // OPTIONAL - Amazon Cognito Web Client ID
          userPoolWebClientId: AWS.userPoolWebClientId, 
          // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
          mandatorySignIn: false,
          // OPTIONAL - Configuration for cookie storage
          // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
          cookieStorage: {
          // REQUIRED - Cookie domain (only required if cookieStorage is provided)
              domain: '.localhost:8000',
          // OPTIONAL - Cookie path
              path: '/',
          // OPTIONAL - Cookie expiration in days
              expires: 365,
          // OPTIONAL - Cookie secure flag
          // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
              secure: true
          },
          // OPTIONAL - customized storage object
          storage: localStorage,
          // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
          authenticationFlowType: 'USER_PASSWORD_AUTH'
      },
      API: {
          endpoints: [
              {
                  name: AWS.endPointName,
                  endpoint: AWS.endPoint,
              }
          ]
      }
    });
    return Amplify.Auth.signIn(username, password)
            .then(function (data) {
            console.log(data);
            // alert('サインインに成功しました');            
            return data;
        }).catch(function (err) {
            console.log(err);
            // alert(err);
        });
  }

  public logout(): Promise<any> {
    return Amplify.Auth.signOut()
            .then(function (data) {
            console.log(data);         
            // alert('サインアウトしました');
        }).catch(function (err) {
            console.log(err);
            // alert(err);
        });
  }

  public prod(): Promise<any> {    
    var apiName = AWS.endPointName;
    var path = '/';
    var myInit = {
        body:{
            "function" : "TRIAL_SHOP",
            "data" : {}
        },
        headers: {} // OPTIONAL
    }
    return Amplify.API.post(apiName, path, myInit).then(response => {
                console.log(response);
                return response;
            }).catch(function (err) {
                console.log(err);
            });
  }

  public terminal(): Promise<any> {    
    var apiName = AWS.endPointName;
    var path = '/';
    var myInit = {
        body:{
            "function" : "GET_TERMINAL_DATA_LIST",
            "data" : {}
        },
        headers: {} // OPTIONAL
    }
    return Amplify.API.post(apiName, path, myInit).then(response => {
                console.log(response);
                return response;
            }).catch(function (err) {
                console.log(err);
            });
  }

  public staffResidentTime(shopId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/staffResidentTime/', {shopId: encodeURIComponent(shopId)});
  }

  public getShopColorOld(shopId: string): Promise<any> {
    var apiName = AWS.endPointName;
    var path = '/';
    var myInit = {
        body:{
            "function" : "SHOP_COLOR",
            "data" : {
              "shopId" : shopId
            }
        },
        headers: {} // OPTIONAL
    }
    return Amplify.API.post(apiName, path, myInit).then(response => {
                console.log(response);
                return response;
            }).catch(function (err) {
                console.log(err);
            });
  }

  public getShopColor(shopId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/loginInfo/', {shopId: encodeURIComponent(shopId)});
  }

  public getShopName(shopId: string): Observable<string> {
    return this.http.get(RestProvider.PREFIX + '/shop/' + encodeURIComponent(shopId), {responseType: 'text'});
  }

  public getMemberType(shopId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/membership/', {shopId: encodeURIComponent(shopId)});
  }

  public getOption(shopId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/option/', {shopId: encodeURIComponent(shopId)});
  }

  public getCalendar(shopId: string): Observable<any> {
    if (typeof shopId === 'undefined') {
      shopId = '000101';
    }
    let now = new Date();
    let year = now.getFullYear();
    let month = ('00' + (now.getMonth() + 1)).slice(-2);
    let day = ('00' + now.getDate()).slice(-2);
    let date = '' + year + month + day;
    return this.http.post(RestProvider.PREFIX + '/calendar/', {shopId: encodeURIComponent(shopId), startDt: date, skipDay: "0", threshold: "18991230" });
  }

  public getAddress(zipCode: string): Observable<any> {
    const params = new HttpParams().set('zipCode', encodeURIComponent(zipCode));
    // return this.http.get(RestProvider.PREFIX + '/address', { params: {zipCode: encodeURIComponent(zipCode)} });
    return this.http.post(RestProvider.PREFIX + '/address', { zipCode: encodeURIComponent(zipCode) });
    // return this.http.request('GET', RestProvider.PREFIX + '/address', { params: {zipCode: encodeURIComponent(zipCode)} });
    // return this.http2.get(RestProvider.PREFIX + '/address', { params: { zipCode: encodeURIComponent(zipCode) } });
  }

  public getBilling(shopId: string, memberType: string, options: Map<string, boolean>, startDate: string): Observable<any> {
    let opts: Array<string> = new Array<string>();
    Object.keys(options).forEach((key) => {
      if (options[key]) {
        opts.push(key);
      }
    });
    const option = (opts.length === 0) ? '-' : opts.join(',');
    return this.http.post(RestProvider.PREFIX + '/billing/', {shopId: encodeURIComponent(shopId), memberTypeId: encodeURIComponent(memberType), options: option, startDate: startDate});
  }

  public postMember(rawData: Object): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/memberRegist/', rawData);
  }

  public putMember(memberNo: string, shopId: string, name: string, uid: string, paymentType: string, photo: any, sign: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/memberRegistCSV/', { uid: uid, memberNo: memberNo, shopId: shopId, shopName: name,
    paymentType: paymentType, photo: photo, sign: sign });
  }

  public contractEms(memberNo: string, sign: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/uploadContractForEMS/', { memberNo: memberNo, sign: sign });
  }

  public changeCredit(memberNo: string, shopId: string, name: string, typeid: string, options: any, startDate: any, cardNumber: any, code: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/changeCredit/', { memberNo: memberNo, userNameCc: name, shopId: shopId, memberTypeId: typeid,
      options: options, startDate: startDate, cardNumber: cardNumber, cardLimit: "12", securityCode: code });
  }
  /**
     * urlに含まれるハッシュ値が正しいか検証し、会員番号から退会状況も検索する
     * @param memberid
     * @param time
     * @param hash
     */
  public checkHash(memberid: string, time: string, hash: string): Observable<any> {
      const url = RestProvider.PREFIX + '/checkHash';
      const body = {
        memberId: memberid,
        presentTime: time,
        originHash: hash
      };
      const headers = new HttpHeaders(
        { 'Content-Type': 'application/json;charset=utf-8' },
      );
      return this.http.post<any>(
          url,
          JSON.stringify(body),
          {
              responseType: 'json',
              headers: headers,
          },
      );
	}
}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts